import {
  INVENTORY_SUMMARY_PAGE_REQUEST,
  INVENTORY_SUMMARY_SET_OUTLETS,
  INVENTORY_SUMMARY_ON_CHANGE_DATE,
  INVENTORY_SUMMARY_ON_CHANGE_KEYWORD,
  INVENTORY_SUMMARY_ON_CHANGE_OUTLET_IDS,
  INVENTORY_SUMMARY_SUMMARY_REQUEST,
  INVENTORY_SUMMARY_SET_CURRENT_PAGE,
  INVENTORY_SUMMARY_SET_TOTAL_PAGE,
  INVENTORY_SUMMARY_SET_ITEMS,
  INVENTORY_SUMMARY_SET_ROW_ITEMS,
  INVENTORY_SUMMARY_EXPORT_SUMMARY,
  INVENTORY_SUMMARY_ON_CHANGE_NAMESPACE,
  INVENTORY_SUMMARY_INGREDIENT_INVENTORY_SUMMARY_REQUEST,
  INVENTORY_SUMMARY_SET_INGREDIENTS
} from './constants'

export function pageRequest () {
  return {type: INVENTORY_SUMMARY_PAGE_REQUEST, payload: {}}
}

export function setOutlets (outlets) {
  return {type: INVENTORY_SUMMARY_SET_OUTLETS, payload: {outlets}}
}

export function onChangeOutletIds (outletIds, {startDate, endDate}, namespace) {
  return {type: INVENTORY_SUMMARY_ON_CHANGE_OUTLET_IDS, payload: {outletIds, startDate, endDate, namespace}}
}

export function onChangeDate ({startDate, endDate}, keyword, namespace) {
  return {type: INVENTORY_SUMMARY_ON_CHANGE_DATE, payload: {startDate, endDate, keyword, namespace}}
}

export function onChangeKeyword (keyword, {startDate, endDate}, namespace) {
  return {type: INVENTORY_SUMMARY_ON_CHANGE_KEYWORD, payload: {keyword, startDate, endDate, namespace}}
}

export function summaryRequest (params, previousItems, previousRowItems, namespace) {
  return {type: INVENTORY_SUMMARY_SUMMARY_REQUEST, payload: {namespace, params, previousItems, previousRowItems}}
}

export function setCurrentPage (page) {
  return {type: INVENTORY_SUMMARY_SET_CURRENT_PAGE, payload: {page}}
}

export function setTotalPage (page) {
  return {type: INVENTORY_SUMMARY_SET_TOTAL_PAGE, payload: {page}}
}

export function setItems (items) {
  return {type: INVENTORY_SUMMARY_SET_ITEMS, payload: {items}}
}

export function setRowItems (items) {
  return {type: INVENTORY_SUMMARY_SET_ROW_ITEMS, payload: {items}}
}

export function exportSummary (params, filename, outletId) {
  return {type: INVENTORY_SUMMARY_EXPORT_SUMMARY, payload: {params, filename, outletId}}
}

export function onChangeNamespace (namespace, params) {
  return {type: INVENTORY_SUMMARY_ON_CHANGE_NAMESPACE, payload: {namespace, params}}
}

export function ingInvSummaryRequest (params, previousIngredients, namespace) {
  return {type: INVENTORY_SUMMARY_INGREDIENT_INVENTORY_SUMMARY_REQUEST, payload: {params, previousIngredients, namespace}}
}

export function setIngredients (ingredients) {
  return {type: INVENTORY_SUMMARY_SET_INGREDIENTS, payload: {ingredients}}
}



// WEBPACK FOOTER //
// ./app/actions/inventory/summary/summary.js